export const PLAYBACK_SPEEDS = [2.0, 1.5, 1, 0.5];
